/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_right_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Object to or restrict processing`)
};

const es_privacy_right_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oponerte o restringir el procesamiento`)
};

const de_privacy_right_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widerspruch gegen oder Einschränkung der Verarbeitung`)
};

const nl_privacy_right_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezwaar te maken tegen of verwerking te beperken`)
};

const fr_privacy_right_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous opposer au traitement ou le restreindre`)
};

const it_privacy_right_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opporti o limitare il trattamento`)
};

const pt_br2_privacy_right_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opor-se ou restringir o processamento`)
};

const pt_privacy_right_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opor-se ou restringir o tratamento`)
};

const ja_privacy_right_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理への異議または制限`)
};

const zh_privacy_right_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反对或限制处理`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_right_4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_right_4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_right_4", locale)
	if (locale === "en") return en_privacy_right_4(inputs)
	if (locale === "es") return es_privacy_right_4(inputs)
	if (locale === "de") return de_privacy_right_4(inputs)
	if (locale === "nl") return nl_privacy_right_4(inputs)
	if (locale === "fr") return fr_privacy_right_4(inputs)
	if (locale === "it") return it_privacy_right_4(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_right_4(inputs)
	if (locale === "pt") return pt_privacy_right_4(inputs)
	if (locale === "ja") return ja_privacy_right_4(inputs)
	return zh_privacy_right_4(inputs)
};